<template lang="pug">
    modal(ref="modal", :loading="onLoading('reject-stock-request')")
        template(slot="title") Decline Request
        template(slot="footer")
            button.md-btn.md-raised.m-b-sm.w-xs.green.m-r-sm(
                type="button",
                @click="submit",
                :disabled="onLoading('reject-stock-request')"
            )
                v-loading(loader="reject-stock-request") Submit
        template(slot="body")
            .form-group
                label Reason of rejection
                textarea.form-control(
                    rows="4",
                    name="reason",
                    :disabled="onLoading('reject-stock-request')"
                    v-validate="'required|min:5'",
                    placeholder="State your reason here",
                    key="request-name",
                    :class="{ 'has-error': errors.has('reason') }"
                    type="text",
                    :value="stockRequest.rejected_reason",
                    @input="setStockRequestAttr({ key: 'rejected_reason', value: $event.target.value })"
                )
                span.text-danger(v-if="errors.has('reason')")
                    | {{ errors.first('reason') }}

                p.m-t-sm.text-muted This will notify outlet manager from requested outlet
</template>

<script>
import stockRequestMixin from './stock-request-mixin';
import { mapActions } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    mixins: [stockRequestMixin],

    mounted() {
        this.$on('show', () => {
            this.$refs.modal.$emit('show');
        });
    },

    methods: {
        ...mapActions('stockRequest', [
            'updateStockRequest',
            'setStockRequestAttr',
        ]),

        async submit() {
            const validate = await this.$validator.validate();
            if (!validate) return;

            try {
                await this.updateStockRequest({
                    action: 'reject',
                    status: this.statuses.DECLINED,
                });

                this.$refs.modal.$emit('hide');
                this.swal({ text: 'Stock request has successfully declined' });
            } catch (e) {
                this.swalError({ text: e });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_request/stock-request-edit-reject.vue